const CONSTANTS = {
    NOT_AVAILABLE: "N/A",

    JWT: "JWT",

    API_HOST: process.env.REACT_APP_API_URL || "https://api.evanplayer.app/",

    REACT_APP_WEB_DOMAIN: process.env.REACT_APP_WEB_DOMAIN || "https://homeplayer.app/",

    APP_NAME: process.env.REACT_APP_APPLICATION_NAME || "Home Player",

    APP_COLOR: "black",
};

export default CONSTANTS;
